module.exports = __webpack_public_path__ + "63307ecda8f51ccdcc4b411edb1eec71.svg";